import { render, staticRenderFns } from "./UserAccountPassword.vue?vue&type=template&id=0b2c8938&"
import script from "./UserAccountPassword.vue?vue&type=script&lang=js&"
export * from "./UserAccountPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports